/**
 * Easter Special – Gratis Osterei im Warenkorb
 * better-objects.de | Aktiv: 30. März – 13. April 2026
 *
 * Logik:
 * - 1 Osterei (Farbe wählbar) pro bestelltem Nicht-Osterei-Produkt
 * - Osterei wird automatisch hinzugefügt/aktualisiert/entfernt
 * - Preis muss im Shopify Admin auf 0,00 € gesetzt sein
 */

(function () {
  'use strict';

  // ─── Konfiguration ───────────────────────────────────────────────────────────
  const EASTER_START = new Date('2026-03-30T00:00:00');
  const EASTER_END   = new Date('2026-04-14T00:00:00');

  // Varianten-IDs: Farbe → "ohne Ohren, ohne Haken" – Gratis-Produkt (0 €)
  // Produkt: osterei-gratis
  const COLOR_VARIANTS = {
    'beige':     '56946723127671',
    'olive':     '56946723258743',
    'grau':      '56946723389815',
    'navy blau': '56946723520887',
    'rosa':      '56946723651959',
    'Schwarz':   '56946723783031',
    'Weiß':      '56946723914103',
    'baby blau': '56946724045175',
    'lime':      '56946724176247',
    'Hellbraun': '56946724307319',
  };

  const COLOR_HEX = {
    'beige':     '#C4A882',
    'olive':     '#6B7C3B',
    'grau':      '#9E9E9E',
    'navy blau': '#1A2F6B',
    'rosa':      '#F7A7B7',
    'Schwarz':   '#222222',
    'Weiß':      '#EFEFEF',
    'baby blau': '#8EC8E8',
    'lime':      '#8EC63F',
    'Hellbraun': '#A0724A',
  };

  // ALLE 40 Gratis-Osterei-Varianten (zur Erkennung im Warenkorb)
  // Produkt: osterei-gratis (0 €) – 10 Farben × 4 Formen
  const ALL_OSTEREI_VARIANT_IDS = new Set([
    // beige
    '56946722963831','56946723029367','56946723094903','56946723127671',
    // olive
    '56946723160439','56946723193207','56946723225975','56946723258743',
    // grau
    '56946723291511','56946723324279','56946723357047','56946723389815',
    // navy blau
    '56946723422583','56946723455351','56946723488119','56946723520887',
    // rosa
    '56946723553655','56946723586423','56946723619191','56946723651959',
    // Schwarz
    '56946723684727','56946723717495','56946723750263','56946723783031',
    // Weiß
    '56946723815799','56946723848567','56946723881335','56946723914103',
    // baby blau
    '56946723946871','56946723979639','56946724012407','56946724045175',
    // lime
    '56946724077943','56946724110711','56946724143479','56946724176247',
    // Hellbraun
    '56946724209015','56946724241783','56946724274551','56946724307319',
  ]);

  // ─── State ───────────────────────────────────────────────────────────────────
  let selectedVariantId = null;
  let isSyncing = false;

  // ─── Hilfsfunktionen ─────────────────────────────────────────────────────────

  function isEasterPeriod() {
    const now = new Date();
    return now >= EASTER_START && now <= EASTER_END;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    return res.json();
  }

  /** Alle Osterei-Positionen im Warenkorb (es sollte max. 1 geben) */
  function getOstereiItems(cart) {
    return cart.items.filter(item =>
      ALL_OSTEREI_VARIANT_IDS.has(String(item.variant_id))
    );
  }

  /** Gesamtmenge aller Nicht-Osterei-Produkte → das ist die Ziel-Osterei-Menge */
  function getTargetQty(cart) {
    return cart.items
      .filter(item => !ALL_OSTEREI_VARIANT_IDS.has(String(item.variant_id)))
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  async function cartChange(key, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
  }

  async function cartAdd(variantId, quantity) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity }),
    });
  }

  // ─── Kern-Logik: Osterei im Warenkorb synchronisieren ────────────────────────

  async function syncOsterei() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await fetchCart();
      const targetQty = getTargetQty(cart);
      const ostereiItems = getOstereiItems(cart);

      // --- Alle vorhandenen Osterier entfernen (aufräumen) ---
      // Falls mehrere drin sind (durch manuelles Hinzufügen etc.)
      for (const item of ostereiItems) {
        await cartChange(item.key, 0);
      }

      // --- Wenn keine normalen Produkte: fertig ---
      if (targetQty === 0 || !selectedVariantId) {
        window.location.reload();
        return;
      }

      // --- Korrekte Variante in richtiger Menge hinzufügen ---
      await cartAdd(selectedVariantId, targetQty);
      window.location.reload();

    } catch (err) {
      console.error('[Easter Special] Fehler:', err);
    } finally {
      isSyncing = false;
    }
  }

  // ─── Banner aufbauen ─────────────────────────────────────────────────────────

  function buildBanner(cart) {
    const banner = document.getElementById('easter-special-banner');
    if (!banner) return;

    const targetQty = getTargetQty(cart);

    // Banner ausblenden wenn Warenkorb leer
    if (targetQty === 0) {
      banner.style.display = 'none';
      return;
    }
    banner.style.display = 'block';

    // Aktive Auswahl aus dem Warenkorb ermitteln
    const existingEggs = getOstereiItems(cart);
    if (existingEggs.length > 0 && !selectedVariantId) {
      selectedVariantId = String(existingEggs[0].variant_id);
    }

    // Menge-Anzeige aktualisieren
    const qtyEl = banner.querySelector('.easter-qty');
    if (qtyEl) {
      qtyEl.textContent = targetQty === 1 ? '1 Osterei' : `${targetQty} Osterier`;
    }

    // Farb-Swatches aufbauen
    const container = banner.querySelector('.easter-swatches');
    if (!container) return;
    container.innerHTML = '';

    Object.entries(COLOR_VARIANTS).forEach(([name, variantId]) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'easter-swatch' + (selectedVariantId === variantId ? ' selected' : '');
      btn.title = name;
      btn.setAttribute('aria-label', name);
      btn.style.setProperty('--swatch-color', COLOR_HEX[name]);

      btn.innerHTML = `
        <span class="easter-swatch__inner"></span>
        <span class="easter-swatch__label">${name}</span>
      `;

      btn.addEventListener('click', () => {
        if (isSyncing) return;
        selectedVariantId = variantId;
        container.querySelectorAll('.easter-swatch').forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        // Loading-Zustand anzeigen
        btn.classList.add('loading');
        syncOsterei();
      });

      container.appendChild(btn);
    });
  }

  // ─── Auf Mengenänderungen reagieren ──────────────────────────────────────────

  function watchCartChanges() {
    // Taste Theme: Menge wird per form submit / section reload aktualisiert
    // → nach jedem Page-Load neu initialisieren (window.location.reload in syncOsterei)
    // Zusätzlich: auf quantity-Buttons hören
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('.quantity__button');
      if (!btn) return;

      // Nicht für Osterei-Zeile reagieren
      const row = btn.closest('tr');
      if (row && row.classList.contains('cart-item--gift')) return;

      // Kurz warten bis Shopify den Cart aktualisiert hat
      setTimeout(async () => {
        const cart = await fetchCart();
        const targetQty = getTargetQty(cart);
        const existingEggs = getOstereiItems(cart);
        const currentEggQty = existingEggs.reduce((s, i) => s + i.quantity, 0);

        buildBanner(cart);

        // Sync wenn nötig
        if (selectedVariantId && currentEggQty !== targetQty) {
          syncOsterei();
        }
      }, 1500);
    });

    // Form-Submit (Menge direkt eingeben + Enter)
    document.addEventListener('change', async (e) => {
      if (!e.target.matches('.quantity__input')) return;
      const row = e.target.closest('tr');
      if (row && row.classList.contains('cart-item--gift')) return;

      setTimeout(async () => {
        const cart = await fetchCart();
        const targetQty = getTargetQty(cart);
        const existingEggs = getOstereiItems(cart);
        const currentEggQty = existingEggs.reduce((s, i) => s + i.quantity, 0);

        buildBanner(cart);
        if (selectedVariantId && currentEggQty !== targetQty) {
          syncOsterei();
        }
      }, 1500);
    });
  }

  // ─── Init ────────────────────────────────────────────────────────────────────

  async function init() {
    if (!isEasterPeriod()) return;

    const banner = document.getElementById('easter-special-banner');
    if (!banner) return; // Nicht auf der Cart-Seite

    const cart = await fetchCart();
    buildBanner(cart);
    watchCartChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
